import React from 'react';
import { FONT_FAMILY, MODAL_BORDER_RADIUS } from '../../components/constants/style-constants';

import './Error.css';
import { useCommon } from '../../store/CommonContext';

interface Props {}

const CheckoutError: React.FC<Props> = () => {
  const {
    state: { configuration },
  } = useCommon();

  return (
    <div className="ui-widget-challenge" id="ui-widget-dialog">
      <div className="ui-widget-challenge-form">
        <div
          className="ui-widget-dialog"
          style={{
            ...(configuration?.fontFamily && { fontFamily: configuration.fontFamily as string }),
            ...(configuration?.modalCornersRadius && { borderRadius: configuration.modalCornersRadius as string }),
          }}
        >
          <div className="ui-widget-content ui-widget-content-challenge">
            <div className="">
              <h1 className="ui-widget-title" style={{ color: 'rgb(29, 29, 40)' }}>
                Error
              </h1>
              <div className="ui-widget-text ui-widget-text-center">Ooops something went wrong.</div>
              <div className="ui-widget-spacer"></div>
              <div className="ui-widget-text ui-widget-text-center">
                Try to refresh this page or feel free to contact us if the problem persists.
              </div>
            </div>
          </div>
          <div className="ui-widget-row"></div>
          <div className="ui-widget-row">
            <div className="ui-widget-footer ui-widget-first-item ui-widget-last-item">
              <div className=""></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutError;
